import React from 'react';
import { Card, Col, Progress, Row, Statistic } from 'antd';

type MetricBlockProps = {
  totalLabel: string;
  totalValue: number;
  savedLabel: string;
  savedValue: number;
  unit: string;
  percent: number;
  summaryLabel: string;
  strokeColor: string;
  progressStatus: 'active' | 'success';
};

const MetricBlock = ({
  totalLabel,
  totalValue,
  savedLabel,
  savedValue,
  unit,
  percent,
  summaryLabel,
  strokeColor,
  progressStatus,
}: MetricBlockProps): JSX.Element => (
  <Col xs={24} sm={12} md={8}>
    <Statistic title={totalLabel} value={`${(totalValue || 0).toFixed(2)} ${unit}`} className="mg-b-10" />
    <Statistic title={savedLabel} value={`${(savedValue || 0).toFixed(2)} ${unit}`} className="mg-b-10" />
    <Progress percent={Number(percent.toFixed(0))} status={progressStatus} strokeColor={strokeColor} showInfo={false} />
    <Statistic title={summaryLabel} value={`${percent.toFixed(2)}%`} />
  </Col>
);

type OperationMetricsProps = {
  totalDistance: number;
  distanceSaved: number;
  distanceOptimizationPercent: number;
  fuelConsumption: number;
  fuelSaving: number;
  fuelEfficiencyPercent: number;
  totalOptimumCapacity: number;
  totalUtilizedCapacity: number;
  capacityOptimizationPercent: number;
};

const OperationMetrics = ({
  totalDistance,
  distanceSaved,
  distanceOptimizationPercent,
  fuelConsumption,
  fuelSaving,
  fuelEfficiencyPercent,
  totalOptimumCapacity,
  totalUtilizedCapacity,
  capacityOptimizationPercent,
}: OperationMetricsProps): JSX.Element => (
  <Col span={24}>
    <Card className="modern-card h-100" title="Operation Metrics" bodyStyle={{ padding: '1.5rem' }}>
      <Row gutter={[24, 24]} justify="space-between" align="middle">
        <MetricBlock
          totalLabel="Total Distance"
          totalValue={totalDistance}
          savedLabel="Distance Saved"
          savedValue={distanceSaved}
          unit="KM"
          percent={distanceOptimizationPercent}
          summaryLabel="Distance Optimization"
          strokeColor="#52c41a"
          progressStatus="active"
        />
        <MetricBlock
          totalLabel="Fuel Used"
          totalValue={fuelConsumption}
          savedLabel="Fuel Saved"
          savedValue={fuelSaving}
          unit="L"
          percent={fuelEfficiencyPercent}
          summaryLabel="Fuel Efficiency"
          strokeColor="#1890ff"
          progressStatus="success"
        />
        <MetricBlock
          totalLabel="Total Capacity"
          totalValue={totalOptimumCapacity}
          savedLabel="Utilized Capacity"
          savedValue={totalUtilizedCapacity}
          unit="KG"
          percent={capacityOptimizationPercent}
          summaryLabel="Capacity Utilization Rate"
          strokeColor="#faad14"
          progressStatus="active"
        />
      </Row>
    </Card>
  </Col>
);

export default OperationMetrics;
